const routes = [
    {
        path: "/daily/course-schedules/meb-ylsy-instructor-course-load",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'dailycourseschedule_mebylsyinstructorcourseloadindex'
        }
    }
];

export default routes;
